class AdminKeyService {
    constructor() {
        this.ELECTION_KEYS_KEY = 'electionAdminKeys';
        this.VOTE_KEYS_KEY = 'voteAdminKeys';
    }

    // Election admin keys
    getElectionAdminKey(electionId) {
        const keys = this.getElectionAdminKeys();
        return keys[electionId] || null;
    }

    setElectionAdminKey(electionId, adminKey) {
        const keys = this.getElectionAdminKeys();
        keys[electionId] = adminKey;
        localStorage.setItem(this.ELECTION_KEYS_KEY, JSON.stringify(keys));
    }

    getElectionAdminKeys() {
        const stored = localStorage.getItem(this.ELECTION_KEYS_KEY);
        return stored ? JSON.parse(stored) : {};
    }

    removeElectionAdminKey(electionId) {
        const keys = this.getElectionAdminKeys();
        delete keys[electionId];
        localStorage.setItem(this.ELECTION_KEYS_KEY, JSON.stringify(keys));
    }

    // Vote admin keys
    getVoteAdminKey(voteId) {
        const keys = this.getVoteAdminKeys();
        return keys[voteId] || null;
    }

    setVoteAdminKey(voteId, adminKey) {
        const keys = this.getVoteAdminKeys();
        keys[voteId] = adminKey;
        localStorage.setItem(this.VOTE_KEYS_KEY, JSON.stringify(keys));
    }

    getVoteAdminKeys() {
        const stored = localStorage.getItem(this.VOTE_KEYS_KEY);
        return stored ? JSON.parse(stored) : {};
    }

    removeVoteAdminKey(voteId) {
        const keys = this.getVoteAdminKeys();
        delete keys[voteId];
        localStorage.setItem(this.VOTE_KEYS_KEY, JSON.stringify(keys));
    }

    // Utility methods
    hasElectionAdminKey(electionId) {
        return this.getElectionAdminKey(electionId) !== null;
    }

    hasVoteAdminKey(voteId) {
        return this.getVoteAdminKey(voteId) !== null;
    }

    // Clear all keys
    clearAllKeys() {
        localStorage.removeItem(this.ELECTION_KEYS_KEY);
        localStorage.removeItem(this.VOTE_KEYS_KEY);
    }
}

const adminKeyService = new AdminKeyService();
export default adminKeyService;